<template>
  <div class="analise-ia-page">
    <section class="page-header">
      <div>
        <p class="kicker">Administração</p>
        <h1>{{ pageTitle }}</h1>
      </div>
      <div class="header-actions">
        <v-btn v-if="!modoValidacao" outlined color="secondary" @click="$router.push({ name: 'analise-evidencias-ia.regras' })">
          Regras
        </v-btn>
        <v-btn outlined color="success" :loading="loadingExportacao" @click="exportarResultados">
          XLSX
        </v-btn>
        <v-btn outlined color="success" :loading="loadingExportacaoPdf" @click="exportarResultadosPdf">
          PDF
        </v-btn>
        <v-btn v-if="!modoValidacao" outlined color="warning" :loading="loadingSincronizacao" :disabled="!temDecisoesPendentes" @click="sincronizarDecididas">
          Sincronizar decisoes
        </v-btn>
        <v-btn outlined color="primary" :loading="loadingPainel" @click="carregarPainel">
          Atualizar
        </v-btn>
      </div>
    </section>

    <v-row>
      <v-col cols="12" md="2" v-for="card in cards" :key="card.label">
        <v-card outlined class="metric-card">
          <v-card-text>
            <div class="text-overline">{{ card.label }}</div>
            <div class="text-h5">{{ card.value }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-alert
      v-if="!modoValidacao"
      class="mb-4"
      :type="runtime.openAiApiKeyConfigurada ? 'success' : 'warning'"
      outlined
      dense
    >
      Avaliacao automatica: {{ runtime.openAiApiKeyConfigurada ? "configurada" : "indisponivel" }}
    </v-alert>

    <v-alert v-if="modoValidacao" class="mb-4" type="info" outlined dense>
      <strong>Validacao de evidencias</strong> - as decisoes desta tela permanecem na camada de analise IA e nao sao sincronizadas automaticamente com PerguntasEvidencias.
    </v-alert>

    <v-card v-if="modoValidacao" outlined class="mb-4 validation-filters-card">
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="2">
            <v-select
              v-model="filtro.origemEvidencia"
              :items="origensValidacao"
              item-text="text"
              item-value="value"
              label="Origem da evidencia"
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filtro.temasIds"
              :items="temas"
              item-text="nome"
              item-value="temaId"
              label="Temas"
              multiple
              chips
              small-chips
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filtro.municipiosIds"
              :items="municipiosFiltrados"
              item-text="nome"
              item-value="id"
              label="Municipios"
              multiple
              chips
              small-chips
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-checkbox
              v-model="filtro.somenteSemEvidenciaAprovada"
              label="Somente sem evidencia aprovada"
              hide-details
              class="mt-0"
            />
          </v-col>
          <v-col cols="12" md="2" class="validation-filters-actions">
            <v-btn text small @click="limparFiltrosValidacao">Limpar</v-btn>
            <v-btn color="primary" small :loading="loadingPainel" @click="carregarPainel">Aplicar filtros</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card v-if="!modoValidacao" outlined class="mb-4">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <v-select v-model="filtro.tipoBase" :items="tiposBase" label="Base" outlined dense />
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              v-model="filtro.origemEvidencia"
              :items="origensEvidencias"
              item-text="text"
              item-value="value"
              label="Origem"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field v-model.number="filtro.ciclo" label="Ciclo" type="number" outlined dense />
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filtro.uf" :items="ufs" label="UF" outlined dense clearable />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filtro.temasIds"
              :items="temas"
              item-text="nome"
              item-value="temaId"
              label="Temas"
              multiple
              chips
              small-chips
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filtro.municipiosIds"
              :items="municipiosFiltrados"
              item-text="nome"
              item-value="id"
              label="Municípios"
              multiple
              chips
              small-chips
              outlined
              dense
              clearable
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleSomenteElegiveisIan">
                  <v-list-item-action>
                    <v-checkbox :input-value="filtro.somenteElegiveisIan" color="primary" readonly hide-details />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Somente elegiveis IAN</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item ripple @click="toggleTodosMunicipios">
                  <v-list-item-action>
                    <v-checkbox :input-value="todosMunicipiosSelecionados()" color="primary" readonly hide-details />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Selecionar todos</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filtro.codigosQuesitos"
              :items="quesitos"
              item-text="label"
              item-value="codigoQuesito"
              label="Quesitos"
              multiple
              chips
              small-chips
              outlined
              dense
              clearable
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleTodosQuesitos">
                  <v-list-item-action>
                    <v-checkbox :input-value="todosQuesitosSelecionados()" color="primary" readonly hide-details />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Selecionar todos</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" md="3">
            <v-checkbox v-model="filtro.incluirAprovadas" label="Incluir aprovadas" hide-details class="mt-0" />
          </v-col>
          <v-col cols="12" md="3">
            <v-checkbox v-model="filtro.incluirRejeitadas" :label="isOrigemIaColeta ? 'Incluir NAO/REVIEW' : 'Incluir rejeitadas'" hide-details class="mt-0" />
          </v-col>
          <v-col cols="12" md="6" class="panel-actions">
            <v-btn outlined color="warning" :loading="loadingSincronizacao" :disabled="!temDecisoesPendentes" @click="sincronizarDecididas">
              Sincronizar decisoes
            </v-btn>
            <v-btn outlined color="primary" :loading="loadingPreview" @click="preview">
              Preview
            </v-btn>
            <v-btn color="primary" :loading="loadingExecucao" @click="criarExecucao">
              Criar execução
            </v-btn>
          </v-col>
        </v-row>
        <v-alert v-if="previewInfo" type="info" outlined class="mt-4">
          {{ previewInfo.totalMunicipios }} municípios, {{ previewInfo.totalQuesitos }} quesitos, {{ previewInfo.totalEvidencias }} evidências.
          <div v-for="aviso in previewInfo.avisos" :key="aviso">{{ aviso }}</div>
        </v-alert>
      </v-card-text>
    </v-card>

    <v-card outlined class="mb-4">
      <v-tabs v-if="!modoValidacao" v-model="tab" background-color="transparent" color="primary">
        <v-tab>Execuções</v-tab>
        <v-tab>Resultados</v-tab>
      </v-tabs>
      <v-divider />
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-data-table
            :headers="headersExecucoes"
            :items="painel.execucoes"
            :loading="loadingPainel"
            class="elevation-0"
            :items-per-page="10"
            no-data-text="Nenhuma execução encontrada."
          >
            <template v-slot:item.criadoEm="{ item }">{{ formatDate(item.criadoEm) }}</template>
            <template v-slot:item.status="{ item }">
              <v-chip small dark :color="statusColor(item.status)">{{ item.status }}</v-chip>
            </template>
            <template v-slot:item.acoes="{ item }">
              <v-btn
                v-if="podeRetomarExecucao(item)"
                small
                outlined
                color="primary"
                :loading="loadingExecucaoId === item.analiseEvidenciasIaExecucaoId"
                :disabled="loadingExecucaoId !== null && loadingExecucaoId !== item.analiseEvidenciasIaExecucaoId"
                @click="retomarExecucao(item)"
              >
                Retomar
              </v-btn>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <div v-if="modoValidacao" class="validation-batch-toolbar">
            <div><strong>{{ itensSelecionados.length }}</strong> evidencia(s) selecionada(s)</div>
            <div class="validation-batch-actions">
              <v-btn small color="success" :disabled="!itensSelecionados.length" @click="abrirDecisaoLote('APROVAR')">Aprovar lote</v-btn>
              <v-btn small color="warning" :disabled="!itensSelecionados.length" @click="abrirDecisaoLote('REVISAO')">Revisao em lote</v-btn>
              <v-btn small color="error" :disabled="!itensSelecionados.length" @click="abrirDecisaoLote('REJEITAR')">Rejeitar lote</v-btn>
            </div>
          </div>
          <v-data-table
            v-model="itensSelecionados"
            :headers="headersResultados"
            :items="painel.resultados"
            :loading="loadingPainel"
            :show-select="modoValidacao"
            item-key="analiseEvidenciasIaItemId"
            class="elevation-0 results-table"
            :items-per-page="15"
            no-data-text="Nenhum resultado encontrado."
          >
            <template v-slot:item.origemEvidencia="{ item }">
              <v-chip x-small outlined>{{ sourceLabel(item.origemEvidencia) }}</v-chip>
            </template>
            <template v-slot:item.nomeArquivo="{ item }">
              <button
                type="button"
                class="evidence-file-link"
                :disabled="!canDownloadEvidence(item) || downloadingEvidenceId === evidenceDownloadKey(item)"
                :title="item.nomeArquivo || 'Baixar evidência'"
                @click.stop="downloadEvidence(item)"
              >
                <v-icon x-small class="mr-1">mdi-download</v-icon>
                <span>{{ item.nomeArquivo || "Baixar evidência" }}</span>
              </button>
            </template>
            <template v-slot:item.decisaoIa="{ item }">
              <v-chip small dark :color="decisionColor(item.decisaoIa)">{{ item.decisaoIa || "PENDENTE" }}</v-chip>
            </template>
            <template v-slot:item.confiancaIa="{ item }">{{ formatPercent(item.confiancaIa) }}</template>
            <template v-slot:item.pontuacaoIa="{ item }">{{ formatDecimal(item.pontuacaoIa) }}</template>
            <template v-slot:item.justificativaIa="{ item }">
              <div class="line-clamp" :title="managerJustification(item)">{{ managerJustification(item) }}</div>
            </template>
            <template v-slot:item.decisaoHumana="{ item }">
              <span>{{ item.decisaoHumana || "Sem decisao" }}</span>
              <div class="sync-status">Final: {{ item.decisaoFinalHumana || "-" }}</div>
            </template>
            <template v-slot:item.sincronizado="{ item }">
              <v-chip x-small :color="item.sincronizado ? 'green' : 'grey'" dark>{{ item.sincronizado ? "SIM" : "NAO" }}</v-chip>
            </template>
            <template v-slot:item.acoes="{ item }">
              <v-btn icon small title="Detalhes" @click="abrirDetalhe(item)">
                <v-icon small color="blue-grey">mdi-information-outline</v-icon>
              </v-btn>
              <v-btn icon small title="Aceitar" @click="abrirDecisao(item, 'ACEITAR')">
                <v-icon small color="green">mdi-check</v-icon>
              </v-btn>
              <v-btn icon small title="Rejeitar" @click="abrirDecisao(item, 'REJEITAR')">
                <v-icon small color="red">mdi-close</v-icon>
              </v-btn>
              <v-btn icon small title="Alterar" @click="abrirDecisao(item, 'ALTERAR')">
                <v-icon small color="primary">mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small title="Sincronizar decisao" :disabled="modoValidacao || isItemIaColeta(item) || item.sincronizado || !podeSincronizarItem(item)" @click="sincronizarItem(item)">
                <v-icon small color="orange">mdi-sync</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog v-model="dialogDecisao" max-width="680">
      <v-card>
        <v-card-title>{{ decisaoEmLote ? `Decisao humana em lote (${itensSelecionados.length})` : "Decisao humana" }}</v-card-title>
        <v-card-text>
          <v-select v-model="decisaoForm.decisaoHumana" :items="decisoesHumanas" label="Decisao" outlined dense />
          <v-select
            v-model="decisaoForm.decisaoFinal"
            :items="decisoesFinais"
            label="Decisao final da evidencia"
            outlined
            dense
            :hint="modoValidacao || isOrigemIaColeta ? 'A decisao sera registrada somente na camada IA.' : 'Use APROVAR ou REJEITAR para sincronizar com a area final de evidencias.'"
            persistent-hint
          />
          <v-textarea v-model="decisaoForm.justificativaHumana" label="Justificativa" outlined rows="4" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDecisao = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="savingDecisao" @click="salvarDecisao">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDetalhe" max-width="860">
      <v-card>
        <v-card-title>Detalhes da analise</v-card-title>
        <v-card-text v-if="itemDetalhe">
          <div class="detail-grid">
            <div><strong>{{ primeiraColunaLabel }}</strong><span>{{ itemDetalhe.municipio }}</span></div>
            <div><strong>Quesito</strong><span>{{ itemDetalhe.codigoQuesito }}</span></div>
            <div><strong>Decisao IA</strong><span>{{ itemDetalhe.decisaoIa || "-" }}</span></div>
            <div><strong>Pontuacao</strong><span>{{ formatDecimal(itemDetalhe.pontuacaoIa) }}</span></div>
          </div>
          <h3>Descricao detalhada</h3>
          <p>{{ itemDetalhe.descricaoDetalhadaIa || "Nao registrada." }}</p>
          <h3>Parecer tecnico</h3>
          <p>{{ itemDetalhe.parecerTecnicoIa || itemDetalhe.justificativaIa || "Nao registrado." }}</p>
          <h3>Fundamento da pontuacao</h3>
          <p>{{ itemDetalhe.fundamentoPontuacaoIa || itemDetalhe.faixaPontuacaoIa || "Nao registrado." }}</p>
          <h3 v-if="isCapacitacao(itemDetalhe)">Capacitacao</h3>
          <div v-if="isCapacitacao(itemDetalhe)" class="detail-grid">
            <div><strong>Atendente</strong><span>{{ itemDetalhe.atendenteCertificadoIa || "-" }}</span></div>
            <div><strong>Horas validas</strong><span>{{ formatDecimal(itemDetalhe.horasValidasIa) }}</span></div>
            <div><strong>Cursos validos</strong><span>{{ formatDecimal(itemDetalhe.cursosValidosIa) }}</span></div>
            <div><strong>Qtd. diagnostico</strong><span>{{ formatDecimal(itemDetalhe.qtdAtendentesDiagnosticoIa) }}</span></div>
          </div>
          <p v-if="isCapacitacao(itemDetalhe)">{{ itemDetalhe.resumoCapacitacaoSalaIa || "Resumo consolidado ainda nao registrado." }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDetalhe = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { atualUfDefinition } from "../../../helpers/utils";
import { analiseEvidenciasIaApi } from "../services/api";

function resolveUfAtual() {
  if (atualUfDefinition && atualUfDefinition.uf) {
    return String(atualUfDefinition.uf).toUpperCase();
  }
  return "RJ";
}

function resolveTipoBaseAtual() {
  const host = (window.location.hostname || "").toLowerCase();
  return host.includes("cidadeempreendedora") ? "cidade" : "selo";
}

function isCodigoQuesitoIan(codigo) {
  const numero = Number(String(codigo || "").replace(",", "."));
  return numero >= 1001 && numero < 1050;
}

export default {
  name: "AnaliseEvidenciasIaPainel",
  props: {
    validacao: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tab: this.validacao ? 1 : 0,
      loadingPainel: false,
      loadingPreview: false,
      loadingExecucao: false,
      loadingExecucaoId: null,
      progressoExecucao: null,
      loadingExportacao: false,
      loadingExportacaoPdf: false,
      loadingSincronizacao: false,
      savingDecisao: false,
      downloadingEvidenceId: null,
      previewInfo: null,
      filtros: { municipios: [], temas: [], quesitos: [], ufs: [], tiposBase: [], origensEvidencias: [] },
      runtime: { openAiApiKeyConfigurada: false, modeloBusca: "", modeloValidador: "" },
      painel: { resumo: {}, runtime: {}, execucoes: [], resultados: [] },
      itensSelecionados: [],
      filtro: {
        tipoBase: resolveTipoBaseAtual(),
        ciclo: 2026,
        uf: resolveUfAtual(),
        municipiosIds: [],
        temasIds: [],
        codigosQuesitos: [],
        origemEvidencia: this.validacao ? "ia-coleta" : "workflow",
        origemTela: this.validacao ? "analise-evidencias-ia-validacao" : "analise-evidencias-ia-painel",
        somenteElegiveisIan: false,
        somenteSemEvidenciaAprovada: false,
        incluirAprovadas: false,
        incluirRejeitadas: false,
      },
      dialogDecisao: false,
      dialogDetalhe: false,
      itemDecisao: null,
      decisaoEmLote: false,
      itemDetalhe: null,
      decisaoForm: { decisaoHumana: "ACEITAR", decisaoFinal: "APROVAR", justificativaHumana: "" },
      decisoesHumanas: ["ACEITAR", "REJEITAR", "ALTERAR"],
      decisoesFinais: ["APROVAR", "REJEITAR", "REVISAO"],
      headersExecucoes: [
        { text: "Execução", value: "codigoExecucao" },
        { text: "Base", value: "tipoBase" },
        { text: "Ciclo", value: "ciclo" },
        { text: "UF", value: "uf" },
        { text: "Status", value: "status" },
        { text: "Evidências", value: "totalEvidencias" },
        { text: "Criado em", value: "criadoEm" },
        { text: "", value: "acoes", sortable: false, align: "end" },
      ],
      headersResultados: [
        { text: "Município", value: "municipio" },
        { text: "Quesito", value: "codigoQuesito" },
        { text: "Fonte", value: "origemEvidencia" },
        { text: "Arquivo", value: "nomeArquivo" },
        { text: "IA", value: "decisaoIa" },
        { text: "Conf.", value: "confiancaIa" },
        { text: "Pontos", value: "pontuacaoIa" },
        { text: "Justificativa", value: "justificativaIa" },
        { text: "Humano", value: "decisaoHumana" },
        { text: "Sync", value: "sincronizado" },
        { text: "", value: "acoes", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    modoValidacao() {
      return !!this.validacao;
    },
    pageTitle() {
      return this.modoValidacao ? "Análise de Evidências - IA - Validação" : "Análise de Evidências - IA";
    },
    primeiraColunaLabel() {
      return this.filtro.tipoBase === "selo" ? "Sala/Parceiro" : "Município";
    },
    cards() {
      const resumo = this.painel.resumo || {};
      return [
        { label: "Execuções", value: resumo.totalExecucoes || 0 },
        { label: "Evidências", value: resumo.totalEvidencias || 0 },
        { label: "Aprovar IA", value: resumo.aprovadasIa || 0 },
        { label: "Rejeitar IA", value: resumo.rejeitadasIa || 0 },
        { label: "Revisão", value: resumo.revisaoIa || 0 },
        { label: "Decididas", value: resumo.decididasHumano || 0 },
      ];
    },
    tiposBase() {
      return this.filtros.tiposBase && this.filtros.tiposBase.length ? this.filtros.tiposBase : ["selo", "cidade"];
    },
    origensEvidencias() {
      const values = this.filtros.origensEvidencias && this.filtros.origensEvidencias.length
        ? this.filtros.origensEvidencias
        : ["workflow", "ia-coleta"];

      return values.map((value) => ({
        value,
        text: this.sourceLabel(value),
      }));
    },
    origensValidacao() {
      return [
        { value: "todos", text: "Humano e IA" },
        { value: "workflow", text: "Humano" },
        { value: "ia-coleta", text: "IA" },
      ];
    },
    isOrigemIaColeta() {
      return this.filtro.origemEvidencia === "ia-coleta";
    },
    ufs() {
      return this.filtros.ufs && this.filtros.ufs.length ? this.filtros.ufs : [resolveUfAtual()];
    },
    municipiosFiltrados() {
      return (this.filtros.municipios || []).filter((m) => {
        const mesmaUf = !this.filtro.uf || m.uf === this.filtro.uf;
        const elegivel = !this.filtro.somenteElegiveisIan || m.elegivelIan;
        return mesmaUf && elegivel;
      });
    },
    temas() {
      return (this.filtros.temas || []).slice().sort((a, b) => String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR"));
    },
    quesitos() {
      return (this.filtros.quesitos || [])
        .filter((q) => isCodigoQuesitoIan(q.codigoQuesito))
        .filter((q) => !this.filtro.temasIds.length || this.filtro.temasIds.includes(q.temaId))
        .map((q) => ({
          ...q,
          label: `${q.codigoQuesito} - ${q.tema || q.pergunta || ""}`,
        }));
    },
    temDecisoesPendentes() {
      return (this.painel.resultados || []).some((item) => this.podeSincronizarItem(item));
    },
  },
  watch: {
    "filtro.uf"() {
      this.removerSelecoesInvalidas();
      this.previewInfo = null;
    },
    "filtro.somenteElegiveisIan"() {
      this.removerSelecoesInvalidas();
      this.previewInfo = null;
    },
    "filtro.origemEvidencia"() {
      this.previewInfo = null;
    },
    "filtro.temasIds"() {
      this.removerSelecoesInvalidas();
      this.previewInfo = null;
    },
  },
  async mounted() {
    await this.carregarRuntime();
    await this.carregarFiltros();
    await this.carregarPainel();
  },
  methods: {
    async carregarRuntime() {
      this.runtime = await analiseEvidenciasIaApi.obterRuntime();
    },
    async carregarFiltros() {
      this.filtros = await analiseEvidenciasIaApi.obterFiltros();
      if (!this.tiposBase.includes(this.filtro.tipoBase)) {
        this.filtro.tipoBase = this.tiposBase[0] || "cidade";
      }
      if (!this.origensEvidencias.some((origem) => origem.value === this.filtro.origemEvidencia)) {
        this.filtro.origemEvidencia = this.modoValidacao ? "ia-coleta" : "workflow";
      }
      this.removerSelecoesInvalidas();
    },
    toggleSomenteElegiveisIan() {
      this.filtro.somenteElegiveisIan = !this.filtro.somenteElegiveisIan;
    },
    todosMunicipiosSelecionados() {
      const ids = this.municipiosFiltrados.map((m) => m.id);
      return ids.length > 0 && ids.every((id) => this.filtro.municipiosIds.includes(id));
    },
    toggleTodosMunicipios() {
      const ids = this.municipiosFiltrados.map((m) => m.id);
      if (!ids.length) return;

      if (this.todosMunicipiosSelecionados()) {
        this.filtro.municipiosIds = this.filtro.municipiosIds.filter((id) => !ids.includes(id));
      } else {
        this.filtro.municipiosIds = Array.from(new Set([...(this.filtro.municipiosIds || []), ...ids]));
      }
    },
    todosQuesitosSelecionados() {
      const codigos = this.quesitos.map((q) => q.codigoQuesito);
      return codigos.length > 0 && codigos.every((codigo) => this.filtro.codigosQuesitos.includes(codigo));
    },
    toggleTodosQuesitos() {
      const codigos = this.quesitos.map((q) => q.codigoQuesito);
      if (!codigos.length) return;

      if (this.todosQuesitosSelecionados()) {
        this.filtro.codigosQuesitos = this.filtro.codigosQuesitos.filter((codigo) => !codigos.includes(codigo));
      } else {
        this.filtro.codigosQuesitos = Array.from(new Set([...(this.filtro.codigosQuesitos || []), ...codigos]));
      }
    },
    removerSelecoesInvalidas() {
      const municipiosValidos = new Set(this.municipiosFiltrados.map((m) => m.id));
      const quesitosValidos = new Set(this.quesitos.map((q) => q.codigoQuesito));
      this.filtro.municipiosIds = (this.filtro.municipiosIds || []).filter((id) => municipiosValidos.has(id));
      this.filtro.codigosQuesitos = (this.filtro.codigosQuesitos || []).filter((codigo) => quesitosValidos.has(codigo));
    },
    async limparFiltrosValidacao() {
      this.filtro.origemEvidencia = "ia-coleta";
      this.filtro.temasIds = [];
      this.filtro.municipiosIds = [];
      this.filtro.somenteSemEvidenciaAprovada = false;
      await this.carregarPainel();
    },
    async carregarPainel() {
      this.loadingPainel = true;
      try {
        this.painel = await analiseEvidenciasIaApi.obterPainel(this.filtro);
        this.itensSelecionados = [];
        this.runtime = this.painel.runtime || this.runtime;
      } finally {
        this.loadingPainel = false;
      }
    },
    async preview() {
      this.loadingPreview = true;
      try {
        this.previewInfo = await analiseEvidenciasIaApi.preview(this.filtro);
      } finally {
        this.loadingPreview = false;
      }
    },
    async criarExecucao() {
      this.loadingExecucao = true;
      try {
        await analiseEvidenciasIaApi.criarExecucao(this.filtro);
        await this.carregarPainel();
        this.tab = 1;
      } finally {
        this.loadingExecucao = false;
      }
    },
    podeRetomarExecucao(item) {
      if (!item || !item.analiseEvidenciasIaExecucaoId) return false;
      return ["PLANEJADA", "EM_EXECUCAO", "FALHA"].includes(item.status);
    },
    async retomarExecucao(item) {
      if (!this.podeRetomarExecucao(item)) return;
      const id = item.analiseEvidenciasIaExecucaoId;
      const confirmou = window.confirm(
        `Retomar a execução ${item.codigoExecucao || id}? Somente itens ainda não processados serão analisados.`,
      );
      if (!confirmou) return;

      this.loadingExecucaoId = id;
      this.progressoExecucao = null;
      try {
        let resultado = null;
        do {
          resultado = await analiseEvidenciasIaApi.processarExecucaoLote(id, null, 5);
          this.progressoExecucao = resultado;
        } while (
          resultado &&
          !resultado.concluida &&
          resultado.processadosNestaChamada > 0
        );

        if (resultado && resultado.concluida) {
          this.$notification.success(
            `Execução concluída: ${resultado.totalProcessados} de ${resultado.totalPlanejado} evidências.`,
          );
        } else {
          this.$notification.error(
            "A execução foi pausada sem itens processados no último lote. Atualize o painel antes de tentar novamente.",
          );
        }
      } catch (error) {
        const mensagem =
          (error && error.response && error.response.data && error.response.data.mensagem) ||
          "Falha ao retomar a execução. Os itens já concluídos foram preservados.";
        this.$notification.error(mensagem);
      } finally {
        this.loadingExecucaoId = null;
        await this.carregarPainel();
      }
    },
    abrirDetalhe(item) {
      this.itemDetalhe = item;
      this.dialogDetalhe = true;
    },
    abrirDecisao(item, decisao) {
      this.itemDecisao = item;
      this.decisaoEmLote = false;
      this.decisaoForm = {
        decisaoHumana: decisao,
        decisaoFinal: this.resolveDecisaoFinalPadrao(item, decisao),
        justificativaHumana: item.justificativaHumana || this.managerJustification(item),
      };
      this.dialogDecisao = true;
    },
    abrirDecisaoLote(decisaoFinal) {
      if (!this.itensSelecionados.length) return;
      this.itemDecisao = null;
      this.decisaoEmLote = true;
      this.decisaoForm = {
        decisaoHumana: decisaoFinal === "REJEITAR" ? "REJEITAR" : "ALTERAR",
        decisaoFinal,
        justificativaHumana: "",
      };
      this.dialogDecisao = true;
    },
    async salvarDecisao() {
      if (!this.itemDecisao && !this.decisaoEmLote) return;
      this.savingDecisao = true;
      try {
        if (this.decisaoEmLote) {
          const resultado = await analiseEvidenciasIaApi.registrarDecisaoLote({
            ...this.decisaoForm,
            itensIds: this.itensSelecionados.map((item) => item.analiseEvidenciasIaItemId),
          });
          this.$notification.success(`${resultado.totalAtualizados} evidencia(s) atualizada(s) na camada IA.`);
          this.itensSelecionados = [];
        } else {
          await analiseEvidenciasIaApi.registrarDecisao(this.itemDecisao.analiseEvidenciasIaItemId, this.decisaoForm);
        }
        this.dialogDecisao = false;
        await this.carregarPainel();
      } finally {
        this.savingDecisao = false;
      }
    },
    async downloadEvidence(item) {
      if (!this.canDownloadEvidence(item)) {
        this.$notification.error("Evidência sem arquivo vinculado.");
        return;
      }

      const downloadKey = this.evidenceDownloadKey(item);
      this.downloadingEvidenceId = downloadKey;
      try {
        const resp = this.isItemIaColeta(item)
          ? await analiseEvidenciasIaApi.downloadIaArquivo(item.origemReferenciaId)
          : await analiseEvidenciasIaApi.downloadEvidencia(item.perguntaEvidenciaId);
        const contentType = resp.headers["content-type"] || "";

        if (contentType.includes("application/json")) {
          const payload = JSON.parse(await resp.data.text());
          if (payload && payload.url) {
            this.openDownloadUrl(payload.url);
            return;
          }
        }

        const blob = new Blob([resp.data], { type: contentType || "application/octet-stream" });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.target = "_blank";
        link.download = item.nomeArquivo || "evidencia";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        this.$notification.error("Erro ao baixar evidência.");
      } finally {
        this.downloadingEvidenceId = null;
      }
    },
    async exportarResultados() {
      this.loadingExportacao = true;
      try {
        const resp = await analiseEvidenciasIaApi.exportarResultados(this.filtro);
        const blob = new Blob([resp.data], {
          type: resp.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "analise-evidencias-ia.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        this.$notification.error("Erro ao exportar resultados.");
      } finally {
        this.loadingExportacao = false;
      }
    },
    async exportarResultadosPdf() {
      this.loadingExportacaoPdf = true;
      try {
        const resp = await analiseEvidenciasIaApi.exportarResultadosPdf(this.filtro);
        const blob = new Blob([resp.data], {
          type: resp.headers["content-type"] || "application/pdf",
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "analise-evidencias-ia.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        this.$notification.error("Erro ao exportar PDF.");
      } finally {
        this.loadingExportacaoPdf = false;
      }
    },
    async sincronizarItem(item) {
      if (!item || !item.analiseEvidenciasIaItemId) return;
      if (this.isItemIaColeta(item)) {
        this.$notification.error("Itens da coleta IA devem ser inseridos no workflow antes da sincronizacao.");
        return;
      }
      this.loadingSincronizacao = true;
      try {
        const resultado = await analiseEvidenciasIaApi.sincronizarItem(item.analiseEvidenciasIaItemId, this.origemTelaAtual());
        this.notificarSincronizacao(resultado);
        await this.carregarPainel();
      } finally {
        this.loadingSincronizacao = false;
      }
    },
    async sincronizarDecididas() {
      if (this.isOrigemIaColeta) {
        const confirmou = window.confirm(
          "As evidencias aprovadas pelo humano dentro dos filtros atuais serao inseridas e aprovadas. " +
          "Quesitos ainda sem SIM receberao um acompanhamento finalizado por tema, e o IAN sera recalculado. Deseja continuar?",
        );
        if (!confirmou) return;
      }
      this.loadingSincronizacao = true;
      try {
        const resultado = await analiseEvidenciasIaApi.sincronizarDecididas({
          ...this.filtro,
          origemTela: this.origemTelaAtual(),
        });
        this.notificarSincronizacao(resultado);
        await this.carregarPainel();
      } finally {
        this.loadingSincronizacao = false;
      }
    },
    notificarSincronizacao(resultado) {
      const total = resultado && resultado.totalSincronizados ? resultado.totalSincronizados : 0;
      if (total > 0) {
        const evidencias = resultado.totalEvidenciasInseridas || total;
        const acompanhamentos = resultado.totalAcompanhamentosCriados || 0;
        const marcador = resultado.marcador ? ` Marcador: ${resultado.marcador}.` : "";
        this.$notification.success(
          `${evidencias} evidencia(s) sincronizada(s); ${acompanhamentos} acompanhamento(s) criado(s).${marcador}`,
        );
      } else {
        const aviso = resultado && resultado.avisos && resultado.avisos.length ? resultado.avisos[0] : "Nenhuma decisao sincronizada.";
        this.$notification.error(aviso);
      }
    },
    resolveDecisaoFinalPadrao(item, decisaoHumana) {
      if (decisaoHumana === "ACEITAR") {
        return item && item.decisaoIa ? item.decisaoIa : "REVISAO";
      }
      if (decisaoHumana === "REJEITAR") {
        return "REJEITAR";
      }
      return item && item.decisaoFinalHumana ? item.decisaoFinalHumana : "APROVAR";
    },
    podeSincronizarItem(item) {
      if (!item || item.sincronizado) return false;
      if (this.isItemIaColeta(item)) {
        return !!item.decisaoHumana && item.decisaoFinalHumana === "APROVAR";
      }
      return (
        item.decisaoFinalHumana === "APROVAR" ||
        item.decisaoFinalHumana === "REJEITAR" ||
        item.decisaoIa === "APROVAR" ||
        item.decisaoIa === "REJEITAR"
      );
    },
    origemTelaAtual() {
      return this.modoValidacao ? "analise-evidencias-ia-validacao" : "analise-evidencias-ia-painel";
    },
    sourceLabel(value) {
      if (value === "todos") return "Humano e IA";
      return value === "ia-coleta" ? "IA" : "Humano";
    },
    managerJustification(item) {
      if (!item) return "";
      const values = [item.justificativaIa, item.parecerTecnicoIa, item.descricaoDetalhadaIa]
        .filter((value) => !!String(value || "").trim());
      const substantive = values.find((value) => !this.isGenericIaComment(value));
      return substantive || values[0] || "";
    },
    isGenericIaComment(value) {
      const text = String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
      return !text ||
        text.includes("enviar para analise complementar ou revisao humana para reduzir falsos positivos") ||
        text.includes("enviar para analise complementar/ocr ou revisao humana") ||
        text.includes("nao foi possivel estruturar a avaliacao automatica") ||
        /motivo:\s*(porem|entretanto|contudo|todavia|mas)(\.|$)/.test(text);
    },
    isItemIaColeta(item) {
      return item && item.origemEvidencia === "ia-coleta";
    },
    evidenceDownloadKey(item) {
      if (!item) return null;
      return this.isItemIaColeta(item)
        ? `ia-${item.origemReferenciaId || ""}`
        : `wf-${item.perguntaEvidenciaId || ""}`;
    },
    canDownloadEvidence(item) {
      if (!item) return false;
      return this.isItemIaColeta(item) ? !!item.origemReferenciaId : !!item.perguntaEvidenciaId;
    },
    openDownloadUrl(url) {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("pt-BR");
    },
    formatPercent(value) {
      if (value === null || value === undefined) return "-";
      return `${Math.round(Number(value) * 100)}%`;
    },
    formatDecimal(value) {
      if (value === null || value === undefined || value === "") return "-";
      return Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 2 });
    },
    isCapacitacao(item) {
      return item && (item.codigoQuesito === "5.0" || item.codigoQuesito === "2.3");
    },
    statusColor(status) {
      if (status === "CONCLUIDA" || status === "CONCLUIDA_TRIAGEM") return "green";
      if (status === "ERRO" || status === "FALHA") return "red";
      if (status === "PLANEJADA") return "orange";
      return "blue";
    },
    decisionColor(decision) {
      if (decision === "APROVAR") return "green";
      if (decision === "REJEITAR") return "red";
      if (decision === "REVISAO") return "orange";
      return "grey";
    },
  },
};
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.kicker {
  margin: 0 0 4px;
  font-size: 12px;
  text-transform: uppercase;
  color: #546e7a;
}
.page-header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
}
.header-actions,
.panel-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.metric-card {
  border-radius: 6px;
}
.validation-filters-card {
  background: #fbfcfe;
}
.validation-filters-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}
.line-clamp {
  max-width: 520px;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.results-table {
  font-size: 13px;
}
.validation-batch-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: #f5f8fb;
  border-bottom: 1px solid #e0e6ed;
}
.validation-batch-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.evidence-file-link {
  display: inline-flex;
  align-items: flex-start;
  max-width: 280px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1a5dcc;
  font: inherit;
  line-height: 1.35;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
}
.evidence-file-link:disabled {
  color: #78909c;
  cursor: default;
  text-decoration: none;
}
.evidence-file-link span {
  overflow-wrap: anywhere;
}
.sync-status {
  margin-top: 2px;
  font-size: 11px;
  color: #607d8b;
}
.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.detail-grid div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.detail-grid strong {
  font-size: 12px;
  color: #546e7a;
}
@media (max-width: 960px) {
  .page-header,
  .header-actions,
  .panel-actions {
    display: block;
  }
  .header-actions .v-btn,
  .panel-actions .v-btn {
    margin: 4px 4px 0 0;
  }
  .validation-batch-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .validation-filters-actions {
    justify-content: flex-start;
  }
}
</style>
